"use client"

import {useTranslations} from "next-intl"
import {AnonymousWarningModal as SharedModal} from "@donista/shared/components/anonymous-warning-modal/web"

interface AnonymousWarningModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    onSignIn: () => void
    onContinueAnonymous: () => void
}

export function AnonymousWarningModal({open, onOpenChange, onSignIn, onContinueAnonymous}: AnonymousWarningModalProps) {
    const t = useTranslations("components.anonymousWarningModal")
    return (
        <SharedModal
            open={open}
            onOpenChange={onOpenChange}
            onSignIn={onSignIn}
            onContinueAnonymous={onContinueAnonymous}
            translations={{
                title: t("title"),
                description: t("description"),
                donationDataRisk: t("donationDataRisk"),
                dataDeletionRisk: t("dataDeletionRisk"),
                multiDeviceRisk: t("multiDeviceRisk"),
                signInButton: t("signInButton"),
                continueAnonymousButton: t("continueAnonymousButton"),
            }}
        />
    )
}
